import React from "react";
import { v4 as uuidv4 } from "uuid";

export function useUUID() {
  const uuid = React.useMemo(() => uuidv4(), []);
  return uuid;
}
